import React from 'react';

const partners = [
  {
    name: "Blum Verwaltungs- & Treuhand AG",
    logo: "https://customer-assets.emergentagent.com/job_swissfirmawert/artifacts/n2gh85mt_blum-logo.webp",
    url: "https://www.blum-treuhand.ch"
  },
  {
    name: "First Direct",
    logo: "https://customer-assets.emergentagent.com/job_swissfirmawert/artifacts/9u8dy8px_firstdirect.webp",
    url: "https://www.firstdirect.ch"
  },
  {
    name: "Schweizer Nachfolge",
    logo: "https://customer-assets.emergentagent.com/job_swissfirmawert/artifacts/93byl7ss_Schweizer%20Nachfolge_Logo.webp",
    url: "https://www.schweizernachfolge.ch"
  },
  {
    name: "LIVAG",
    logo: "https://customer-assets.emergentagent.com/job_swissfirmawert/artifacts/i7z6foqx_LIVAG%20Logo_Schwarz%20Transparent.webp",
    url: "https://www.livag.ch"
  },
  {
    name: "Bratschi",
    logo: "/partners/bratschi.webp",
    url: "https://www.bratschi.ch/"
  },
  {
    name: "Stach Rechtsanwälte",
    logo: "https://customer-assets.emergentagent.com/job_valuewizard/artifacts/1efe4c0v_stach-logo-web.webp",
    url: "https://stach.ch/"
  },
  {
    name: "Leader Digital",
    logo: "/partners/leader.webp",
    url: "https://www.leaderdigital.ch/"
  }
];

const PartnersSection = () => {
  // Duplicate partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners, ...partners];

  return (
    <section className="py-8 bg-white overflow-hidden border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <p className="text-center text-[#4a4d4b] text-sm font-medium tracking-wide uppercase">
          Unsere Partner – Ihr neues Netzwerk
        </p>
      </div>

      {/* Carousel Container */}
      <div className="relative">
        {/* Gradient Overlays for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Scrolling Track */}
        <div className="flex animate-scroll-partners">
          {duplicatedPartners.map((partner, index) => (
            <a
              key={`${partner.name}-${index}`}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 mx-4 group"
            >
              <div className="bg-white rounded-xl p-4 w-44 h-28 flex items-center justify-center shadow-md border border-gray-100 transform transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg group-hover:border-[#FF0000]/20">
                <img
                  src={partner.logo}
                  alt={`Logo von ${partner.name}`}
                  className="max-w-full max-h-full object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ maxHeight: '70px' }}
                  loading="lazy"
                  width="150"
                  height="70"
                />
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Animation Keyframes */}
      <style>{`
        @keyframes scroll-partners {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll-partners {
          animation: scroll-partners 25s linear infinite;
        }
        
        .animate-scroll-partners:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default PartnersSection;
